import { colors } from '@piconetworks/pkg-functions';
import { FormBlockBackgroundValue, ThemeBlockBackgroundValue } from '../Properties/BlockBackgroundValue.js';
import PropertyType from '../Modifiers/PropertyType.js';
import { FormPageContrastColor, ThemePageContrastColor } from './PageContrastColor.js';

var getBackgroundColorHex = function getBackgroundColorHex(value) {
  var _sectionBackgroundCol;
  var sectionBackgroundColor = value || 'rgb(255, 255, 255)';
  if ((_sectionBackgroundCol = sectionBackgroundColor) !== null && _sectionBackgroundCol !== void 0 && _sectionBackgroundCol.includes('rgba')) {
    var sectionBackgroundColorAlpha = sectionBackgroundColor.split('(').pop().split(')')[0];
    var _sectionBackgroundCol2 = sectionBackgroundColorAlpha.split(',').map(function (x) {
        return parseFloat(x);
      }),
      r = _sectionBackgroundCol2[0],
      g = _sectionBackgroundCol2[1],
      b = _sectionBackgroundCol2[2];
    sectionBackgroundColor = colors.RgbToHex(r, g, b);
  }
  return sectionBackgroundColor;
};
var getBlockContrastColor = function getBlockContrastColor(_ref) {
  var formBlockBg = _ref.formBlockBg,
    themeBlockBg = _ref.themeBlockBg,
    formPageContrastColor = _ref.formPageContrastColor,
    themePageContrastColor = _ref.themePageContrastColor;
  var contrastColor;
  var blockBackgroundColor;
  var formBlockBackgroundValueHasBeenModified = formBlockBg.getHasBeenModified();
  if (formBlockBackgroundValueHasBeenModified) {
    blockBackgroundColor = formBlockBg.getValue();
  } else {
    blockBackgroundColor = themeBlockBg.getValue();
  }
  // if the block background is transparent, just set the contrast color to be the same as the page contrast color
  // if the form page color hasn't been modified, then we can just use the theme page contrast color
  if (blockBackgroundColor === 'transparent') {
    var formPageContrastColorHasBeenModified = formPageContrastColor.getHasBeenModified();
    if (formPageContrastColorHasBeenModified) {
      contrastColor = formPageContrastColor.getValue();
    } else {
      contrastColor = themePageContrastColor.getValue();
    }
  } else {
    var sectionBackgroundColor = getBackgroundColorHex(blockBackgroundColor);
    contrastColor = colors.getContrastColor(sectionBackgroundColor);
  }
  var _colors$hexToRgb = colors.hexToRgb(contrastColor),
    redTextColor = _colors$hexToRgb.r,
    greenTextColor = _colors$hexToRgb.g,
    blueTextColor = _colors$hexToRgb.b;
  var textColorRgb = "rgb(" + redTextColor + ", " + greenTextColor + ", " + blueTextColor + ")";
  return textColorRgb;
};
var selectors = '.block';
var ThemeBlockContrastColor = new PropertyType({
  name: 'BlockContrastColor',
  propertyFromApi: 'block-contrast-color',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return "color: " + value + ";";
  },
  selector: selectors,
  isCompounded: true,
  cssVariable: '--block-contrast-color',
  priority: 5,
  convertToRgb: true
}, 'theme');
var FormBlockContrastColor = new PropertyType({
  name: 'BlockContrastColor',
  propertyFromApi: 'block-contrast-color',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return "color: " + getBlockContrastColor({
      formBlockBg: FormBlockBackgroundValue,
      themeBlockBg: ThemeBlockBackgroundValue,
      formPageContrastColor: FormPageContrastColor,
      themePageContrastColor: ThemePageContrastColor
    }) + ";";
  },
  selector: selectors,
  isCompounded: true,
  cssVariable: '--block-contrast-color',
  cssVariableFunction: function cssVariableFunction(value) {
    return getBlockContrastColor({
      formBlockBg: FormBlockBackgroundValue,
      themeBlockBg: ThemeBlockBackgroundValue,
      formPageContrastColor: FormPageContrastColor,
      themePageContrastColor: ThemePageContrastColor
    });
  },
  priority: 6,
  convertToRgb: true
}, 'form');

export { FormBlockContrastColor, ThemeBlockContrastColor };
//# sourceMappingURL=BlockContrastColor.js.map
